<template>
  <template v-if="hasAdvertisementLink(currentAd)">
    <a
      v-if="isExternalAdvertisementLink(currentAd)"
      :href="getExternalLink(currentAd?.link)"
      target="_blank"
      rel="noopener noreferrer"
      class="w-full flex mt-2"
    >
      <img
        class="rounded-lg h-36 w-full object-cover"
        :src="currentAd?.image"
        alt="poster-banner-small"
      />
    </a>
    <router-link
      v-else
      :to="{
        name: getRouteParams(currentAd).name,
        params: getRouteParams(currentAd).params,
        query: getRouteParams(currentAd).query,
      }"
      class="w-full flex mt-2"
    >
      <img
        class="rounded-lg h-36 w-full object-cover"
        :src="currentAd?.image"
        alt="poster-banner-small"
      />
    </router-link>
  </template>
  <div v-else class="w-full flex mt-2">
    <img
      class="rounded-lg h-36 w-full object-cover"
      :src="currentAd?.image"
      alt="poster-banner-small"
    />
  </div>
</template>

<script>
import { LINK_TYPE } from '@/constants';
import {
  getRouteParams,
  getExternalLink,
  hasAdvertisementLink,
  isExternalAdvertisementLink,
} from '@/helpers';

export default {
  name: 'PosterBannerSmall',
  props: {
    content: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      adInterval: null,
      adImageIndex: 0,
      time: 0,
      currentAd: {
        link: '/',
        link_type: 0,
        image: '/img/logo.webp',
      },
      linkType: LINK_TYPE,
    };
  },
  methods: {
    getRouteParams,
    getExternalLink,
    hasAdvertisementLink,
    isExternalAdvertisementLink,
    runInterval() {
      this.time = this.currentAd?.duration * 1000;
      this.adInterval = setInterval(this.changeImage, this.time);
    },
    changeImage() {
      this.adImageIndex = (this.adImageIndex + 1) % this.content.length;
      this.currentAd = this.content[this.adImageIndex];
      clearInterval(this.adInterval);
      this.runInterval();
    },
  },
  mounted() {
    this.currentAd = this.content[0];
    if (this.content.length > 1) {
      this.runInterval(); // Change image every 30 seconds
    }
  },
  unmounted() {
    clearInterval(this.adInterval);
  },
};
</script>
